module.exports = "<app-archive-employee-overview *ngIf=\"type == 'EMPLOYEE'\"></app-archive-employee-overview>\n<app-archive-client-overview *ngIf=\"type == 'CLIENT'\"></app-archive-client-overview>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/archive/archive.component.html
// module id = ../../../../../src/app/components/archive/archive.component.html
// module chunks = main